import { type CSSProperties } from 'typestyle/lib/types';
import { type SxProps } from '@mui/material';
import StyleConstants from '../../styles.constants';

export const wrapper: CSSProperties = {
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  color: StyleConstants.GREY_COLOR,
};

export const label: CSSProperties = {
  marginTop: 8,
};

export const tooltip: CSSProperties = {
  width: 250,
};

export const tooltipIcon: CSSProperties = {
  cursor: 'pointer',
  color: StyleConstants.GREY_COLOR,
  height: 18,
  width: 18,
};

export const tooltipIconSX: SxProps = {
  cursor: 'pointer',
  color: StyleConstants.GREY_COLOR,
  height: 18,
  width: 18,
};
